<div class="parallex">
	<div class="legacy-section help-section">
		<div class="container container-mobile">
			<h2>{{ title }}</h2>

			<div class="will-legacy-content">
				@for (item of items(); track item.title) {
				<div class="will-legacy-block">
					<div class="will-legacy-image">
						<img [src]="item.imageSrc" [alt]="item.imageAlt" />
					</div>
					<div class="will-legacy-text">
						<div class="item-heading">{{ item.title }}</div>
						@for (paragraph of item.paragraphs; track paragraph) {
						<p>{{ paragraph }}</p>
						}
					</div>
				</div>
				}
			</div>

			@if (cta) {
				<div class="will-cta-button">
					<button
						type="button"
						class="btn btn-primary btn-block action-btn"
						(click)="onCtaClick()">
						{{ cta.title }}
					</button>
				</div>
			}
		</div>
	</div>
</div>
